import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const services = [
  {
    title: "Sublimation T-Shirts",
    blurb:
      "Edge-to-edge all-over sublimation prints on 140–180 GSM polyester. Photo-sharp colour fidelity, no cracking, no fading. The go-to method for cricket team jerseys, marathon kits, fan merchandise and design-heavy fashion drops.",
    bg: "#FF0055",
    fg: "#FFFFFF",
    img: "https://customer-assets.emergentagent.com/job_landing-forge-60/artifacts/v7eynedl_WhatsApp%20Image%202026-05-05%20at%2016.55.34%20%281%29.jpeg",
    tag: "01",
  },
  {
    title: "Custom Uniforms",
    blurb:
      "Schools, cafés, restaurants, hospitals, retail chains and corporate teams. Consistent batch dyeing, durable construction and embroidered logos that survive 50+ washes. Sizes XS to 5XL across t-shirts, polos, shirts, aprons and overalls.",
    bg: "#FFE600",
    fg: "#0A0A0A",
    img: "https://customer-assets.emergentagent.com/job_landing-forge-60/artifacts/ck3frgau_WhatsApp%20Image%202026-05-05%20at%2016.55.36.jpeg",
    tag: "02",
  },
  {
    title: "Promotional Merch",
    blurb:
      "Caps, tote bags, mugs, water bottles, keychains and stationery — branded with your logo or campaign artwork via computerised embroidery, screen print or DTF. The kind of giveaways that stick around long after the event ends. Bulk pricing from 50 pieces.",
    bg: "#00F0FF",
    fg: "#0A0A0A",
    img: "https://customer-assets-7cd3h4nn.emergentagent.net/job_landing-forge-60/artifacts/vqz4p9cv_WhatsApp%20Image%202026-09-16%20at%2014.11.03.jpeg",
    tag: "03",
  },
  {
    title: "Workwear & Outerwear",
    blurb:
      "Industrial boiler suits and windcheater jackets, made-to-order for factories, garages, delivery fleets, college fests and marathon kits. Reinforced construction, custom fabrics, embroidery-ready.",
    bg: "#0A0A0A",
    fg: "#FFE600",
    img: "https://customer-assets.emergentagent.com/job_landing-forge-60/artifacts/nga7vw36_COTTON%20POLO%20BLACK.jpeg",
    tag: "04",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      className="border-b-4 border-black py-20 lg:py-28 bg-[#FDFDFD]"
      data-testid="services-section"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14">
        <div className="flex items-end justify-between flex-wrap gap-6 mb-12 lg:mb-16">
          <div>
            <div className="font-heading uppercase text-xs tracking-[0.3em] text-[#555] mb-4">
              /// What we make
            </div>
            <h2 className="font-heading uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight max-w-3xl">
              Four services.<br />
              <span className="bg-[#00F0FF] nb-border-2 px-2 inline-block">One obsession —</span>{" "}
              your brand, wearable.
            </h2>
          </div>
          <a href="#contact" className="nb-btn" data-testid="services-cta">
            Request Catalogue <ArrowUpRight size={18} strokeWidth={3} />
          </a>
        </div>

        <div className="grid grid-cols-12 gap-6 lg:gap-8">
          {services.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className={`relative col-span-12 md:col-span-6 nb-border-4 nb-shadow overflow-hidden flex flex-col`}
              style={{ background: s.bg, color: s.fg }}
              data-testid={`service-card-${i}`}
            >
              <div className="flex items-start justify-between p-6 md:p-8">
                <div className="font-heading uppercase text-6xl md:text-7xl opacity-90">
                  {s.tag}
                </div>
                <div className="text-right max-w-[60%]">
                  <h3 className="font-heading uppercase text-2xl md:text-3xl leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-3 text-sm md:text-base leading-relaxed opacity-90">
                    {s.blurb}
                  </p>
                </div>
              </div>
              <div className="relative border-t-4 border-black aspect-[16/9] overflow-hidden">
                {s.video ? (
                  <video
                    src={s.video}
                    poster={s.img}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="metadata"
                    className="absolute inset-0 w-full h-full object-cover"
                    aria-label={s.title}
                  />
                ) : (
                  <img
                    src={s.img}
                    alt={s.title}
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                  />
                )}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
